import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal } from 'antd'
import AppointmentRevisitAppointmentAudit from './audit'
import AlumniCertificationDetail from '../certification/detail'

const AlumniOrganizationJoinDetail = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [appointmentDetail, setAppointmentDetail] = useState({})
  const [propsData, setPropsData] = useState({})
  const [isAuditVisible, setIsAuditVisible] = useState(false)
  const [isAlumniVisible, setIsAlumniVisible] = useState(false)

  const getAppointmentDetail = () => {
    axios.post('/p/alumni/organization_member_application/detail/get', {
      merchant_oid: merchantOid,
      appointment_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setAppointmentDetail(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getAppointmentDetail()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, props.data.oid])

  const handleCancel = () => {
    props.isCancel()
  }

  const getColor = () => {
    if (appointmentDetail.status.key === 2) return 'green'
    if (appointmentDetail.status.key === 3) return 'red'
    return 'black'
  }

  const openAudit = () => {
    setIsAuditVisible(true)
    setPropsData({ 
      oid: appointmentDetail.oid,
      status: appointmentDetail.status.key,
      failureReason: appointmentDetail.failure_reason
    })
  }

  const openAlumni = () => {
    setIsAlumniVisible(true)
    setPropsData({ 
      oid: appointmentDetail.alumni_oid
    })
  }

  return (
    <Modal 
      title="详情"
      destroyOnClose={true}
      width='700px'
      open={props.isOpen}
      onCancel={handleCancel}
      footer={false}>
      
      <div className='public-datail-container'>
        <div className='public-datail-item'>
          <div className='public-datail-label'>申请时间</div>
          <div className='public-datail-content'>{appointmentDetail.create_time}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>申请人</div>
          <div className='public-datail-status'>{appointmentDetail.alumni_name}</div>
          <div className='public-datail-button3' onClick={openAlumni}>查看校友详情</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>申请加入的组织</div>
          <div className='public-datail-content'>{appointmentDetail.organization_name}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>申请理由</div>
          <div className='public-datail-content'>{appointmentDetail.join_reason}</div>
        </div>

        {appointmentDetail.status && 
          <div className='public-datail-item'>
            <div className='public-datail-label'>审核状态</div>
            <div style={{ color: getColor() }} className='public-datail-status'>{appointmentDetail.status.value}</div>
            <div className='public-datail-button' onClick={openAudit}>审核</div>
          </div>
        }
        {(appointmentDetail.status && appointmentDetail.status.key === 3) &&
          <div className='public-datail-item'>
            <div className='public-datail-label'>拒绝原因</div>
            <div className='public-datail-content'>{appointmentDetail.failure_reason || '未填写'}</div>
          </div>
        }
      </div>

      {isAuditVisible && <AppointmentRevisitAppointmentAudit
        data={propsData}
        getAppointmentDetail={getAppointmentDetail}
        getAppointmentData={() => { props.getAppointmentData() }}
        isOpen={isAuditVisible}
        isCancel={() => { setIsAuditVisible(false) }}
      />}
      {isAlumniVisible && <AlumniCertificationDetail
        data={propsData}
        isOpen={isAlumniVisible}
        isCancel={() => { setIsAlumniVisible(false) }}
        showAudit={false}
      />}
    </Modal>
  )
}

export default AlumniOrganizationJoinDetail
